import { render, staticRenderFns } from "./ServiceMenuStatusIconWithText.vue?vue&type=template&id=449441b6&scoped=true&"
import script from "./ServiceMenuStatusIconWithText.vue?vue&type=script&lang=ts&"
export * from "./ServiceMenuStatusIconWithText.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceMenuStatusIconWithText.vue?vue&type=style&index=0&id=449441b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449441b6",
  null
  
)

export default component.exports